import FlagIcon from '@mui/icons-material/FlagOutlined';
import isNumber from 'lodash/isNumber';
import { useTranslation } from 'react-i18next';
import { generatePath } from 'react-router-dom';

import { RoutePath } from 'applications/GSP/shared/constants/router';
import { useFormatDateWithTimezone } from 'applications/GSP/shared/hooks/dates';
import {
  ArrowForwardCell,
  NavigationDataRow,
  TitleCell,
  ValueCell,
} from 'shared/components/DataRow';
import { formatDate } from 'shared/utils/date';

import type { InspiredGlobalStudyPlatformApiModelsAssignmentOverview as Assignment } from 'applications/GSP/shared/api/gsp';
import type { FC } from 'react';

interface GradeRowProps extends Assignment {
  onClick(): void;
}

export const FLAG_ICON_TEST_ID = 'flag-icon';

export const GradeRow: FC<GradeRowProps> = ({
  id,
  subjectId,
  categoryName,
  subjectName,
  name,
  date,
  mark,
  countsTowardsFinalGrade,
  onClick,
}) => {
  const { t } = useTranslation();
  const formatDateWithTimeZone = useFormatDateWithTimezone(formatDate);

  return (
    <NavigationDataRow
      to={generatePath(RoutePath.AssignmentDetails, {
        subjectId,
        assignmentId: id,
      })}
      onClick={onClick}
    >
      <TitleCell
        aboveTitle={categoryName}
        title={subjectName}
        subtitle={`${date && formatDateWithTimeZone(new Date(date))} | ${name}`}
        startAdornment={
          countsTowardsFinalGrade && (
            <FlagIcon color="secondary" data-testid={FLAG_ICON_TEST_ID} />
          )
        }
      />
      <ValueCell
        sx={{ display: { xs: 'none', sm: 'block' } }}
        label={`${t(
          'GSP.pages.dashboard.widgets.latestGrades.content.result',
        )}:`}
        value={mark?.grade ? mark.grade : t('GSP.na.label')}
      />
      <ValueCell
        label={`${t(
          'GSP.pages.dashboard.widgets.latestGrades.content.score',
        )}:`}
        value={
          isNumber(mark?.percentage)
            ? `${mark?.percentage}%`
            : t('GSP.na.label')
        }
      />
      <ArrowForwardCell />
    </NavigationDataRow>
  );
};
